import { render, staticRenderFns } from "./KOR.vue?vue&type=template&id=cc594c5a&scoped=true&"
import script from "./KOR.vue?vue&type=script&lang=js&"
export * from "./KOR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc594c5a",
  null
  
)

export default component.exports